export const ROLES = { ADMIN: 'admin', STUDENT: 'student' } as const;
export const rolesDictionary = { admin: 'Administrador', student: 'Estudiante' };
export type RoleType = (typeof ROLES)[keyof typeof ROLES];
